export interface CreditCardInfo {
	firstName: string;
	lastName: string;
	cardNumber: string;
	cardExpirationMonth: string;
	cardExpirationYear: string;
	cardCvv: string;
	cardType: string;
	cbsCT: string;
}

export const defaultCreditCardInfo: CreditCardInfo = {
	firstName: '',
	lastName: '',
	cardNumber: '',
	cardExpirationMonth: '',
	cardExpirationYear: '',
	cardCvv: '',
	cardType: '',
	cbsCT: '',
};
